// All 32 NFL teams — names match The Odds API format exactly
export const NFL_TEAMS = [
  { name: "Arizona Cardinals",    abbr: "ARI", espnId: "22", conference: "NFC", division: "West" },
  { name: "Atlanta Falcons",      abbr: "ATL", espnId: "1",  conference: "NFC", division: "South" },
  { name: "Baltimore Ravens",     abbr: "BAL", espnId: "33", conference: "AFC", division: "North" },
  { name: "Buffalo Bills",        abbr: "BUF", espnId: "2",  conference: "AFC", division: "East" },
  { name: "Carolina Panthers",    abbr: "CAR", espnId: "29", conference: "NFC", division: "South" },
  { name: "Chicago Bears",        abbr: "CHI", espnId: "3",  conference: "NFC", division: "North" },
  { name: "Cincinnati Bengals",   abbr: "CIN", espnId: "4",  conference: "AFC", division: "North" },
  { name: "Cleveland Browns",     abbr: "CLE", espnId: "5",  conference: "AFC", division: "North" },
  { name: "Dallas Cowboys",       abbr: "DAL", espnId: "6",  conference: "NFC", division: "East" },
  { name: "Denver Broncos",       abbr: "DEN", espnId: "7",  conference: "AFC", division: "West" },
  { name: "Detroit Lions",        abbr: "DET", espnId: "8",  conference: "NFC", division: "North" },
  { name: "Green Bay Packers",    abbr: "GB",  espnId: "9",  conference: "NFC", division: "North" },
  { name: "Houston Texans",       abbr: "HOU", espnId: "34", conference: "AFC", division: "South" },
  { name: "Indianapolis Colts",   abbr: "IND", espnId: "11", conference: "AFC", division: "South" },
  { name: "Jacksonville Jaguars", abbr: "JAX", espnId: "30", conference: "AFC", division: "South" },
  { name: "Kansas City Chiefs",   abbr: "KC",  espnId: "12", conference: "AFC", division: "West" },
  { name: "Las Vegas Raiders",    abbr: "LV",  espnId: "13", conference: "AFC", division: "West" },
  { name: "Los Angeles Chargers", abbr: "LAC", espnId: "24", conference: "AFC", division: "West" },
  { name: "Los Angeles Rams",     abbr: "LAR", espnId: "14", conference: "NFC", division: "West" },
  { name: "Miami Dolphins",       abbr: "MIA", espnId: "15", conference: "AFC", division: "East" },
  { name: "Minnesota Vikings",    abbr: "MIN", espnId: "16", conference: "NFC", division: "North" },
  { name: "New England Patriots", abbr: "NE",  espnId: "17", conference: "AFC", division: "East" },
  { name: "New Orleans Saints",   abbr: "NO",  espnId: "18", conference: "NFC", division: "South" },
  { name: "New York Giants",      abbr: "NYG", espnId: "19", conference: "NFC", division: "East" },
  { name: "New York Jets",        abbr: "NYJ", espnId: "20", conference: "AFC", division: "East" },
  { name: "Philadelphia Eagles",  abbr: "PHI", espnId: "21", conference: "NFC", division: "East" },
  { name: "Pittsburgh Steelers",  abbr: "PIT", espnId: "23", conference: "AFC", division: "North" },
  { name: "San Francisco 49ers",  abbr: "SF",  espnId: "25", conference: "NFC", division: "West" },
  { name: "Seattle Seahawks",     abbr: "SEA", espnId: "26", conference: "NFC", division: "West" },
  { name: "Tampa Bay Buccaneers", abbr: "TB",  espnId: "27", conference: "NFC", division: "South" },
  { name: "Tennessee Titans",     abbr: "TEN", espnId: "10", conference: "AFC", division: "South" },
  { name: "Washington Commanders",abbr: "WSH", espnId: "28", conference: "NFC", division: "East" },
];

export const teamLogoUrl = (espnId) =>
  `https://a.espncdn.com/i/teamlogos/nfl/500/${espnId}.png`;

export const findTeam = (name) =>
  NFL_TEAMS.find((t) => t.name === name || t.abbr === name);

// NFL 2026 regular season week boundaries (UTC)
export const NFL_2026_WEEKS = [
  { week: 1,  start: new Date("2026-09-03T00:00:00Z"), end: new Date("2026-09-16T12:00:00Z") },
  { week: 2,  start: new Date("2026-09-16T12:00:01Z"), end: new Date("2026-09-23T12:00:00Z") },
  { week: 3,  start: new Date("2026-09-23T12:00:01Z"), end: new Date("2026-09-30T12:00:00Z") },
  { week: 4,  start: new Date("2026-09-30T12:00:01Z"), end: new Date("2026-10-07T12:00:00Z") },
  { week: 5,  start: new Date("2026-10-07T12:00:01Z"), end: new Date("2026-10-14T12:00:00Z") },
  { week: 6,  start: new Date("2026-10-14T12:00:01Z"), end: new Date("2026-10-21T12:00:00Z") },
  { week: 7,  start: new Date("2026-10-21T12:00:01Z"), end: new Date("2026-10-28T12:00:00Z") },
  { week: 8,  start: new Date("2026-10-28T12:00:01Z"), end: new Date("2026-11-04T12:00:00Z") },
  { week: 9,  start: new Date("2026-11-04T12:00:01Z"), end: new Date("2026-11-11T12:00:00Z") },
  { week: 10, start: new Date("2026-11-11T12:00:01Z"), end: new Date("2026-11-18T12:00:00Z") },
  { week: 11, start: new Date("2026-11-18T12:00:01Z"), end: new Date("2026-11-25T12:00:00Z") },
  { week: 12, start: new Date("2026-11-25T12:00:01Z"), end: new Date("2026-12-02T12:00:00Z") },
  { week: 13, start: new Date("2026-12-02T12:00:01Z"), end: new Date("2026-12-09T12:00:00Z") },
  { week: 14, start: new Date("2026-12-09T12:00:01Z"), end: new Date("2026-12-16T12:00:00Z") },
  { week: 15, start: new Date("2026-12-16T12:00:01Z"), end: new Date("2026-12-23T12:00:00Z") },
  { week: 16, start: new Date("2026-12-23T12:00:01Z"), end: new Date("2026-12-30T12:00:00Z") },
  { week: 17, start: new Date("2026-12-30T12:00:01Z"), end: new Date("2027-01-06T12:00:00Z") },
  { week: 18, start: new Date("2027-01-06T12:00:01Z"), end: new Date("2027-01-13T12:00:00Z") },
];

export const getCurrentNFLWeek = () => {
  const now = new Date();
  const found = NFL_2026_WEEKS.find((w) => now >= w.start && now <= w.end);
  return found ? found.week : null;
};
